<template>
  <footer
    id="footer"
    class="app-footer padding-y-3xl"
    style="background-color: var(--fa-navy); color: var(--fa-gravy); --link-color: var(--white); --link-hover-color: var(--fa-blue)"
  >
    <div class="container">
      <div class="margin-bottom-2xl">
        <div
          class="margin-y-2xl"
          style="color: var(--white)"
        >
          <h2 class="h5">
            <site-link
              :to="{ name: 'home' }"
              class="display-inline-block margin-right-2xs"
              @click.native="$posthog.capture('main_footer_link_click', { destination: 'home' })"
            >
              <wa-logo-flag />
              <span class="sr-only">Font Awesome</span>
            </site-link>
            Go Make Something Awesome
          </h2>
          <p
            class="laptop:size-sm"
            style="--paragraph-margin-bottom: var(--spacing-2xs)"
          >
            Font Awesome is the internet's icon library and toolkit used by millions of designers, developers, and content creators.
          </p>
          <p class="laptop:size-sm">
            Made with
            <font-awesome-icon
              :icon="$v6.solid.faHeart"
              title="love"
              class="margin-x-4xs app-footer-heart-flutter"
            />
            and
            <wa-question-mark-block
              v-if="selectedFaveIcon === 'faBlockQuestion'"
              block-size="lg"
            />
            <font-awesome-icon
              v-else
              :icon="$v6.solid[selectedFaveIcon]"
              class="margin-x-4xs"
            />
            in
            <a
              class="no-underline"
              href="https://www.google.com/maps/place/Bentonville, AR"
              target="_blank"
              >Bentonville</a
            >,
            <a
              class="no-underline"
              href="https://www.google.com/maps/place/Boston, MA"
              target="_blank"
              >Boston</a
            >,
            <a
              class="no-underline"
              href="https://www.google.com/maps/place/Chicago, IL"
              target="_blank"
              >Chicago</a
            >,
            <a
              class="no-underline"
              href="https://www.google.com/maps/place/Grand Rapids, MI"
              target="_blank"
              >Grand Rapids</a
            >,
            <a
              class="no-underline"
              href="https://www.google.com/maps/place/Joplin, MO"
              target="_blank"
              >Joplin</a
            >,
            <a
              class="no-underline"
              href="https://www.google.com/maps/place/Kansas City, MO"
              target="_blank"
              >Kansas City</a
            >,
            <a
              class="no-underline"
              href="https://www.google.com/maps/place/Seattle, WA"
              target="_blank"
              >Seattle</a
            >,
            <a
              class="no-underline"
              href="https://www.google.com/maps/place/Tampa, FL"
              target="_blank"
              >Tampa</a
            >, and
            <a
              class="no-underline"
              href="https://www.google.com/maps/place/Vergennes, VT"
              target="_blank"
              >Vergennes</a
            >.
          </p>
        </div>

        <div class="row roomy align-top">
          <div class="column-6 tablet:column-3 margin-bottom-xl laptop:margin-bottom-0">
            <h3 class="h5 muted">Awesomeverse</h3>
            <a
              href="https://www.kickstarter.com/projects/fontawesome/web-awesome"
              class="display-block no-underline margin-bottom-2xs"
              @click="$posthog.capture('main_footer_link_click', { destination: 'web_awesome' })"
            >
              Web Awesome
            </a>
            <a
              href="https://www.11ty.dev/"
              class="display-block no-underline margin-bottom-2xs"
              @click="$posthog.capture('main_footer_link_click', { destination: '11ty' })"
            >
              11ty
            </a>
            <a
              href="https://podcastawesome.com/"
              class="display-block no-underline margin-bottom-2xs"
              @click="$posthog.capture('main_footer_link_click', { destination: 'podcast_awesome' })"
            >
              Podcast Awesome
            </a>
            <a
              href="https://blog.fontawesome.com"
              target="_blank"
              class="display-block no-underline"
              @click="$posthog.capture('main_footer_link_click', { destination: 'blog' })"
            >
              Blog Awesome
            </a>
          </div>

          <div class="column-6 tablet:column-3 margin-bottom-xl laptop:margin-bottom-0">
            <h3 class="h5 muted">Font Awesome</h3>
            <site-link
              :to="{ name: 'latest.download' }"
              class="display-block no-underline margin-bottom-2xs"
              @click.native="$posthog.capture('main_footer_link_click', { destination: 'download' })"
            >
              Download
            </site-link>
            <site-link
              :to="{ name: 'changelog' }"
              class="display-block no-underline margin-bottom-2xs"
              @click.native="$posthog.capture('main_footer_link_click', { destination: 'changelog' })"
            >
              Changelog
            </site-link>
            <site-link
              :to="{ name: 'versions' }"
              class="display-block no-underline"
              @click.native="$posthog.capture('main_footer_link_click', { destination: 'versions' })"
            >
              All Versions
            </site-link>
          </div>

          <div class="column-6 tablet:column-3 margin-bottom-xl laptop:margin-bottom-0">
            <h3 class="h5 muted">Community</h3>
            <a
              href="https://github.com/FortAwesome/Font-Awesome"
              target="_blank"
              class="display-block no-underline margin-bottom-2xs"
              @click="$posthog.capture('main_footer_link_click', { destination: 'github_project' })"
            >
              GitHub
            </a>
            <a
              href="https://www.youtube.com/@font.awesome"
              target="_blank"
              class="display-block no-underline margin-bottom-2xs"
              @click="$posthog.capture('main_footer_link_click', { destination: 'youtube' })"
            >
              YouTube
            </a>
            <a
              href="https://www.threads.net/@font.awesome"
              target="_blank"
              class="display-block no-underline margin-bottom-2xs"
              @click="$posthog.capture('main_footer_link_click', { destination: 'threads' })"
            >
              Threads
            </a>
            <a
              href="https://cottonbureau.com/font-awesome"
              class="display-block no-underline"
              @click="$posthog.capture('main_footer_link_click', { destination: 'merch' })"
            >
              Awesome Swag
            </a>
          </div>

          <div class="column-6 tablet:column-3">
            <h3 class="h5 muted">Help</h3>
            <site-link
              :to="{ name: 'support' }"
              class="display-block no-underline margin-bottom-2xs"
              @click.native="$posthog.capture('main_footer_link_click', { destination: 'support' })"
            >
              Support
            </site-link>
            <site-link
              :to="{ name: 'latest.docs', params: { pathMatch: '/web/troubleshoot' } }"
              class="display-block no-underline margin-bottom-2xs"
              @click.native="$posthog.capture('main_footer_link_click', { destination: 'docs_web_troubleshooting' })"
            >
              Troubleshooting
            </site-link>
            <a
              href="mailto:hello@fontawesome.com?subject=Hello, Font Awesome!"
              class="display-block no-underline margin-bottom-2xs"
              @click="supportLinkClicked('page_footer')"
            >
              Contact Us
            </a>
            <a
              href="https://status.fortawesome.com/"
              target="_blank"
              class="display-block no-underline margin-bottom-2xs"
              @click="$posthog.capture('main_footer_link_click', { destination: 'status' })"
            >
              Status
            </a>
          </div>
        </div>
      </div>

      <div class="row roomy align-top tablet:size-sm">
        <div class="margin-bottom-xl display-flex flex-column tablet:flex-row laptop:margin-bottom-0">
          <site-link
            :to="{ name: 'license.pro' }"
            class="display-inline-block no-underline margin-bottom-sm tablet:margin-bottom-0 tablet:margin-right-md"
            @click.native="$posthog.capture('main_footer_link_click', { destination: 'license' })"
          >
            License
          </site-link>
          <site-link
            :to="{ name: 'tos' }"
            class="display-inline-block no-underline margin-bottom-sm tablet:margin-bottom-0 tablet:margin-right-md"
            @click.native="$posthog.capture('main_footer_link_click', { destination: 'terms_of_service' })"
          >
            Terms of Service
          </site-link>
          <site-link
            :to="{ name: 'privacy' }"
            class="display-inline-block no-underline margin-bottom-sm tablet:margin-bottom-0 tablet:margin-right-md"
            @click.native="$posthog.capture('main_footer_link_click', { destination: 'privacy_policy' })"
          >
            Privacy Policy
          </site-link>
          <site-link
            :to="{ name: 'refunds' }"
            class="display-inline-block no-underline margin-bottom-sm tablet:margin-bottom-0 tablet:margin-right-md"
            @click.native="$posthog.capture('main_footer_link_click', { destination: 'refunds' })"
          >
            Refunds
          </site-link>
          <button
            class="link flat text-left margin-0 padding-0 display-inline-block no-underline"
            style="--button-border-radius: 0"
            @click.prevent="manageCookiePreferences"
          >
            Cookie Preferences
          </button>
        </div>
        <div class="column-12 laptop:column laptop:text-right">
          <p style="color: var(--fa-gravy); white-space: nowrap">&copy; Fonticons, Inc.</p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
  import sample from 'lodash/sample'
  import { EventTrackingMixin } from 'app/mixins'
  import { mapActions } from 'vuex'

  const faveIcons = [
    'faAvocado',
    'faBlockQuestion',
    'faBoombox',
    'faCalculator',
    'faClarinet',
    'faComputerClassic',
    'faCroissant',
    'faDiceD20',
    'faFire',
    'faIceCream',
    'faLollipop',
    'faPipeSmoking',
    'faRecordVinyl',
    'faStarfighterTwinIonEngineAdvanced',
    'faSwordLaser',
    'faTreasureChest'
  ]

  export default {
    name: 'PageFooter',

    mixins: [EventTrackingMixin],

    data() {
      return {
        selectedFaveIcon: sample(faveIcons)
      }
    },

    methods: {
      ...mapActions('cookiePreferences', ['manageCookiePreferences'])
    }
  }
</script>
